import { createSlice } from "@reduxjs/toolkit";
import {
  registerTeacher,
  loginTeacher,
  refreshToken,
  logoutTeacher,
  getTeacherProfile,
  loginTeacherWithGoogle,
  verifyTeacherEmailOperation,
} from "./operation.js";

const initialState = {
  teacherToken: null,

  teacherRefreshToken: null,
  refreshToken: null,
  loading: false,
  error: null,
  isLoggedIn: false,
  isRefreshing: false, // ← показывает процесс refresh'а
  isRefreshingSession: true, // ← при старте приложения true
  teacherData: null,
  teacherInfo: {
    avatar: "https://randomuser.me/api/portraits/women/44.jpg", // временно захардкожено
  },
};

const authTeacherSlice = createSlice({
  name: "authTeacher",
  initialState,
  reducers: {
    setRefreshComplete(state) {
      state.isRefreshing = false;
      state.isRefreshingSession = false;
    },
    setTeacherToken: (state, action) => {
      state.teacherToken = action.payload.teacherToken || action.payload;
      state.isLoggedIn = true;
      state.teacherRefreshToken = action.payload.refreshToken || null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Register
      .addCase(registerTeacher.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isLoggedIn = false;
      })
      .addCase(registerTeacher.fulfilled, (state) => {
        state.loading = false;
        state.teacherToken = null;
        state.refreshToken = null;
        state.isLoggedIn = false; // ещё не вошёл
        state.isRefreshing = false;
        state.isRefreshingSession = false;

        // можно оставить сообщение в другом поле, если надо
      })
      .addCase(registerTeacher.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isLoggedIn = false;
        state.isRefreshingSession = false;
      })

      // Login
      .addCase(loginTeacher.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isLoggedIn = false;
        state.isRefreshing = true;
        state.isRefreshingSession = true;
      })
      .addCase(loginTeacher.fulfilled, (state, action) => {
        state.loading = false;
        state.teacherToken = action.payload.teacherToken;
        state.refreshToken = action.payload.refreshToken;
        state.isLoggedIn = true;
        state.isRefreshing = false;
        state.isRefreshingSession = false;
        state.error = null;
      })
      .addCase(loginTeacher.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isLoggedIn = false;
        state.isRefreshing = false;
        state.isRefreshingSession = false;
      })

      // Refresh
      .addCase(refreshToken.pending, (state) => {
        state.isRefreshing = true;
        state.isRefreshingSession = true;
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.teacherToken = action.payload.teacherToken;
        state.isLoggedIn = true;
        state.isRefreshing = false;
        state.isRefreshingSession = false;
        state.error = null;
      })
      .addCase(refreshToken.rejected, (state, action) => {
        if (action.payload === null) {
          // Ожидаемый 401 — просто разлогиниваем
          state.teacherToken = null;
          state.refreshToken = null;
          state.isLoggedIn = false;
          state.isRefreshing = false;
          state.isRefreshingSession = false;
          return;
        }
        // Неожиданная ошибка
        state.error = action.payload;
        state.isRefreshing = false;
        state.isRefreshingSession = false;
      })

      // Logout
      .addCase(logoutTeacher.fulfilled, (state) => {
        state.teacherToken = null;
        state.refreshToken = null;
        state.isLoggedIn = false;
        state.isRefreshing = false;
        state.isRefreshingSession = false;
        state.error = null;
        state.teacherData = null;
      })
      .addCase(logoutTeacher.rejected, (state, action) => {
        state.teacherToken = null;
        state.refreshToken = null;
        state.isLoggedIn = false;
        state.isRefreshing = false;
        state.isRefreshingSession = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getTeacherProfile.fulfilled, (state, action) => {
        state.teacherData = action.payload;
        state.teacherInfo = {
          ...state.teacherInfo,
          ...action.payload,
        };
      })
      // Google
      .addCase(loginTeacherWithGoogle.fulfilled, (state, action) => {
        // state.teacherToken = action.payload;
        // state.isLoggedIn = true;
        // state.error = null;
        state.loading = false;
        state.teacherToken = action.payload.teacherToken;
        state.refreshToken = action.payload.refreshToken;
        state.isLoggedIn = true;
        state.isRefreshing = false;
        state.isRefreshingSession = false;
      })
      .addCase(loginTeacherWithGoogle.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoggedIn = false;
      })
      .addCase(verifyTeacherEmailOperation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyTeacherEmailOperation.fulfilled, (state, action) => {
        state.loading = false;
        state.teacherToken = action.payload;
        state.isLoggedIn = true;
      })
      .addCase(verifyTeacherEmailOperation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setRefreshComplete, setTeacherToken } = authTeacherSlice.actions;
export default authTeacherSlice.reducer;
